// extracted by mini-css-extract-plugin
module.exports = {"donation":"mS","donationIcon":"mT","donationTitle":"mU"};